// Централизованный модуль аналитики.
// Метрика подключается в public/index.html, Calltouch — из utils/calltouch.js,
// здесь — цели, просмотры и отправка заявок.
// ============================================================

// Яндекс.Метрика
export const YM_COUNTER_ID = 111526827;

// Calltouch: ID сайта для приёма заявок через REST API
export const CALLTOUCH_SITE_ID = "75478";

// ID счётчика подмены номеров живёт в одном месте — utils/calltouch.js,
// откуда скрипт и запускается. Здесь он нужен, чтобы вытащить sessionId
// и склеить заявку с рекламным источником.
import { CALLTOUCH_MOD_ID } from "./calltouch";

export { CALLTOUCH_MOD_ID };

/**
 * Получить UTM-метки из URL
 */
export function getUtmParams() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
      const v = params.get(k);
      if (v) utm[k] = v;
    });
    return utm;
  } catch {
    return {};
  }
}

/**
 * Отправить просмотр страницы в Метрику (нужно при SPA-переходах).
 */
export function trackPageView(url) {
  try {
    if (typeof window !== "undefined" && typeof window.ym === "function") {
      window.ym(YM_COUNTER_ID, "hit", url, { referer: document.referrer });
    }
  } catch (e) {
    console.warn("[analytics] trackPageView error:", e);
  }
}

/**
 * Отправить цель в Яндекс.Метрику
 */
export function trackGoal(goalName, params) {
  try {
    if (typeof window !== "undefined" && typeof window.ym === "function") {
      window.ym(YM_COUNTER_ID, "reachGoal", goalName, params || {});
    }
  } catch (e) {
    console.warn("[analytics] trackGoal error:", e);
  }
}

/**
 * Идентификатор сессии Calltouch — нужен, чтобы заявка склеилась
 * с рекламным источником, из которого пришёл посетитель.
 * Штатный способ — ct('calltracking_params', modId).sessionId;
 * остальные варианты оставлены как запасные.
 */
function getCalltouchSessionId() {
  if (typeof window === "undefined") return "";

  try {
    if (typeof window.ct === "function") {
      const params = window.ct("calltracking_params", CALLTOUCH_MOD_ID);
      if (params && params.sessionId) return params.sessionId;
    }
  } catch {
    /* Calltouch ещё не догрузился — падаем на запасные варианты */
  }

  const cookie = document.cookie.match(/(?:^|;\s*)_ct_session_id=([^;]+)/);
  if (cookie) return decodeURIComponent(cookie[1]);

  return window.call_value || window.ct_sid || "";
}

/**
 * Передать заявку в Calltouch (REST API).
 * Ошибку не пробрасываем: посетитель в любом случае должен увидеть
 * страницу «Спасибо», даже если Calltouch недоступен.
 */
function sendCalltouchLead({ name, phone, email, subject }) {
  const url = `https://api.calltouch.ru/calls-service/RestAPI/requests/${CALLTOUCH_SITE_ID}/register/`;

  const params = {
    fio: name || "",
    phoneNumber: phone,
    email: email || "",
    subject: subject || "Заявка с сайта",
    sessionId: getCalltouchSessionId(),
    requestUrl: window.location.href,
  };

  const query = Object.keys(params)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join("&");

  return fetch(`${url}?${query}`, { method: "GET", mode: "no-cors", keepalive: true }).catch(
    (error) => {
      console.warn("[calltouch] не удалось передать заявку:", error);
    }
  );
}

/**
 * Отправка заявки: цель в Метрику + передача лида в Calltouch.
 */
export async function submitLead(payload) {
  const data = {
    ...payload,
    page: window.location.href,
    referrer: document.referrer || "",
    utm: getUtmParams(),
    createdAt: new Date().toISOString(),
  };

  // Цель «Отправка формы»
  trackGoal("form_submit", { source: payload.source || "lead_form" });

  await sendCalltouchLead({
    name: payload.name,
    phone: payload.phone,
    email: payload.email,
    subject: `Заявка с сайта — ${payload.source || "lead_form"}`,
  });

  return data;
}
